export enum SubscriptionType {
    Stock = 1,
    Branded = 2,
    Pro = 3,
    Elite = 4,
    Fleet = 11,
    Route50 = 21,
    Route200 = 22,
    RouteTransactions = 23,
    NationalBanner = 31,
    RegionalBanner = 32,
    Promotion = 35,
    ThirdPartyIntegrator = 41
}
